import { createVanIconComponent } from "./van"

const Logistics = createVanIconComponent("logistics")
export default Logistics
